import { BottomNavigation, BottomNavigationAction, Box, TextField, Tooltip } from '@mui/material';
import List from 'widgets/list/list';
import styles from 'pages/tasks/Tasks.module.css';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { useForm } from 'shared/utils/hooks/useForm';
import { useNavigate } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { CurrentPageTasks, LoadingTasks, TasksList } from 'entities/tasks/selector';
import { fetchTasksList } from 'entities/tasks/actions/fetch-tasks-list';
import { setCurrentPageTasks } from 'entities/tasks';
import CustomButton from 'shared/custom-button/CustomButton';
import AllContractsList from 'widgets/all-contracts-list/AllContractsList';
import SettingsIcon from '@mui/icons-material/Settings';
import { allFields, defaultFields, fieldMappings } from 'features/tasks/utils/constant';
import ModalWidget from 'widgets/modal/Modal';
import TransferList from 'widgets/field-settings/FieldSettings';
import SearchIcon from '@mui/icons-material/Search';
import { ITasks } from 'entities/tasks/types/Tasks-interface';

import appStyles from 'app/providers/theme/App.module.css';
import Loader from 'shared/loader/Loader';


export const Tasks: FC = () => {
    const limit = 10;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const tasks = useAppSelector(TasksList);

    const currentPage = useAppSelector(CurrentPageTasks)

    const isLoading = useAppSelector(LoadingTasks)

    const selectedContracts = {
        list: [],
    };

    const {
        formData,
        handleAutocompeteChange
    } = useForm(selectedContracts);

    const [selectedOptions, setSelectedOptions] = useState('Весь список');

    const sortArray: string[] | [] = ["Date DESC"];
    const [contractID, setContractID] = useState<string | string[]>([]);


    const [fields, setFields] = useState<string[]>(defaultFields);
    const [tempFields, setTempFields] = useState<string[]>(fields);
    const [open, setOpen] = useState(false);

    const [openSearch, setOpenSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState<string>('');

    const handleOpenSearch = () => setOpenSearch((prevState) => !prevState);

    useEffect(() => {
        const offset = limit * (currentPage - 1);
        const contract = Array.isArray(contractID) ? contractID : [contractID];
        const filters = selectedOptions === 'Весь список' ? [] : [];
        dispatch(fetchTasksList({ contractID: contract, sortArray, filters }));

    }, [dispatch, limit, contractID]);
    useEffect(() => {
        dispatch(setCurrentPageTasks({ page: 1 }));
    }, [selectedOptions]);

    const handleChildAction = useCallback((page: number) => {
        dispatch(setCurrentPageTasks({ page }));
    }, [dispatch]);



    const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        dispatch(setCurrentPageTasks({ page: 1 }));
    }, [dispatch]);

    // const filteredTasks = useMemo(() => {
    //     let filteredData = [...tasks];

    //     if (selectedOptions !== 'Весь список') {
    //         filteredData = filteredData.filter(task => task.StatusName === selectedOptions);
    //     }

    //     if (searchQuery) {
    //         filteredData = filteredData.filter((item: ITasks) =>
    //             item.Number.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.ThemeName.toLowerCase().includes(searchQuery.toLowerCase())
    //         );
    //     }

    //     return filteredData;
    // }, [selectedOptions, tasks, searchQuery]);

    // const paginatedTasks = useMemo(() => {
    //     const startIndex = (currentPage - 1) * limit;
    //     return filteredTasks.slice(startIndex, startIndex + limit);
    // }, [currentPage, filteredTasks]);

    const filteredTasks = (() => {
        let filteredData = [...tasks];

        if (selectedOptions !== 'Весь список') {
            filteredData = filteredData.filter(task => task.StatusName === selectedOptions);
        }

        if (searchQuery) {
            filteredData = filteredData.filter((item: ITasks) =>
                item.Number.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.ThemeName.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        return filteredData;
    })();

    const paginatedTasks = () => {
        const startIndex = (currentPage - 1) * limit;
        return filteredTasks.slice(startIndex, startIndex + limit);
    };

    const handleClickNewTask = () => {
        navigate(`/createTask`);
    }
    const renderItem = (item: any) => (
        <Box sx={{
            display: 'flex',
            width: '100%',
            position: 'relative',
        }}>
            {item.UnreadMessagesCounter !== 0 && (
                <Tooltip title="Непрочитанные сообщения" placement="top">
                    <Box sx={{
                        position: 'absolute',
                        left: '15px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'red',
                        color: 'white',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        zIndex: 1, 
                    }}>
                        {item.UnreadMessagesCounter}
                    </Box>
                </Tooltip>

            )}
            {fields.map((field) => {
                const key = fieldMappings[field];
                return (
                    <Box key={field} sx={{ flex: 1 }}>
                        <p>{item[key]}</p>
                    </Box>
                );
            })}
        </Box>
    );
    const handleOpenModal = () => {
        setTempFields(fields);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleReset = () => {
        setTempFields(defaultFields);
    };
    const handleAccept = () => {
        setFields(tempFields);
        setOpen(false);
    };
    const handleTempFieldsChange = (newFields: string[]) => {
        setTempFields(newFields);
    };

    return (
        <Box>
            <Box className={appStyles.titleBox}>
                <h1>Заявки</h1>
            </Box>
            <AllContractsList
                formData={formData}
                handleAutocompeteChange={handleAutocompeteChange}
                setContractID={setContractID}
                multiple={true}
                name="list"
                reducerAction={setCurrentPageTasks}
                disabled={isLoading}
            />
            <Box className={styles.btnNavigation}>
                <CustomButton
                    title="Новая заявка"
                    handleClick={handleClickNewTask}
                    textColor="white"
                    backgroundColor="#0054E6"
                    padding="5px 30px"
                    gap="10px"
                    border='none'
                    borderRadius='4px'

                />
                {!isLoading && tasks.length > 0 && (
                    <Box className={styles.rightBtnNavigation}>
                        <BottomNavigation
                            showLabels
                            value={selectedOptions}
                            onChange={(event, newValue) => {
                                setSelectedOptions(newValue);
                            }}
                            sx={{
                                backgroundColor: 'transparent',
                            }}
                        >
                            <BottomNavigationAction label="Весь список" value="Весь список" sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }} />
                            <BottomNavigationAction label="В работе" value="В работе" sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }} />
                            <BottomNavigationAction label="Черновики" value="Проект" sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }} />
                            <BottomNavigationAction label="Выполнено" value="Выполнено" sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }} />
                            <BottomNavigationAction label="Отмененные" value="Отмененные" sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }} />
                        </BottomNavigation>
                        <Tooltip title="Настройка таблицы" placement="top">
                            <span
                                className={styles.iconContract}
                                onClick={() => handleOpenModal()}
                            >
                                <SettingsIcon />
                            </span>
                        </Tooltip>
                    </Box>
                )}
            </Box>
            <ModalWidget
                open={open}
                handleClose={handleClose}
                title="Настройка полей таблицы"
                closeIconPosition="right"
                showAcceptButton
                showCancelButton
                onAccept={handleAccept}
                onCancel={handleReset}
                widthProps={600}
            >
                <TransferList
                    key={JSON.stringify(tempFields)}
                    defaultFields={tempFields}
                    allFields={allFields}
                    onFieldsChange={handleTempFieldsChange}
                />
            </ModalWidget>
            {!isLoading && tasks.length > 0 && (
                <Box className={appStyles.iconSort}>
                    <span onClick={handleOpenSearch} className={`${openSearch ? appStyles.iconSelected : ''}`}><SearchIcon /></span>
                </Box>
            )}
            {openSearch && (
                <TextField
                    label="Поиск"
                    variant="outlined"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    fullWidth
                    margin="normal"
                />
            )}
            {isLoading && (
                <Loader
                    title='Подготовка списка. Это займет несколько секунд.'
                />
            )}

            {!isLoading && (
                <>
                    {tasks.length > 0 && filteredTasks.length > 0 ? (
                        <Box sx={{
                            width: '100%',
                            overflow: 'hidden',
                            position: 'relative'
                        }}>
                            <List
                                title={fields}
                                data={paginatedTasks()}
                                renderItem={renderItem}
                                renderPagination={filteredTasks.length > 10}
                                pageCount={Math.ceil(filteredTasks.length / 10)}
                                onAction={handleChildAction}
                                currentPage={currentPage}
                                pathnameProps="/tasks/case/"
                                link={true}
                                unreadMessagesCounter={true}
                            />
                        </Box>
                    ) : (
                        <Box className={appStyles.infoBox}>
                            <p>Заявки не найдены</p>
                        </Box>
                    )}
                </>
            )}

        </Box>

    );
};

export default Tasks;
